<script>
import camelCase from 'lodash/camelCase';

export default {
	components: {},
	inheritAttrs: false,
	props: {
		source: {
			type: String,
			default: 'font-awesome'
		},
		name: {
			type: String,
			default: '',
			required: true
		}
	},
	computed: {
		// Gets a CSS module class, e.g. iconCustomLogo
		customIconClass() {
			return this.$style[camelCase('icon-custom-' + this.name)];
		}
	}
};
</script>

<template>
	<span v-bind="$attrs" :class="customIconClass" />
</template>
<style module>
.iconCustomSync {
	color: inherit;
}
</style>
